import { render, staticRenderFns } from "./NewRequestData.vue?vue&type=template&id=082e291b"
import script from "./NewRequestData.vue?vue&type=script&setup=true&lang=tsx"
export * from "./NewRequestData.vue?vue&type=script&setup=true&lang=tsx"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports